import { z } from "zod";

export const EventVersionReleased = z.object({
  type: z.literal("DesignSystemVersionReleased"),
  workspaceId: z.string(),
  designSystemId: z.string(),
  versionId: z.string(),
});

export type EventVersionReleased = z.infer<typeof EventVersionReleased>;
